import { Pipe, PipeTransform, inject } from '@angular/core';
import { DocumentService } from '@services/document.service';
import { IWorkflowDocument } from '@interfaces/nebula';

@Pipe({ name: 'getWorkflowStatus' })
export class GetWorkflowstatusPipe implements PipeTransform {
  private _documentService = inject(DocumentService);

  transform(workflowDocuments: IWorkflowDocument[], arg?: string): string {
    return this._documentService.fetchWorkflowStatus(workflowDocuments, arg);
  }
}
